import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { PRadioProps } from '@/components/atoms/Radio/types';

/**
 * `PRadio` is the design system atom for a single-choice radio group.
 *
 * Accepts `state` for API consistency with the other form-input atoms; `locked` currently renders
 * identically to `disabled` — a selected option isn't ambiguous the way a text value is.
 */
export function PRadio<T = unknown>({ options, itemSx, state = 'enabled', ...other }: PRadioProps<T>) {
  return (
    <RadioGroup {...other}>
      {options.map((option) => (
        <FormControlLabel
          disabled={state !== 'enabled'}
          sx={itemSx}
          key={String(option.value)}
          value={option.value}
          control={<Radio disableRipple />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  );
}
